import React, { forwardRef } from "react";
import { bool, string } from "prop-types";

import * as S from "./styled";

const RadioInput = forwardRef(
  ({ disabled, label, name, value, ...props }, ref) => (
    <S.Label disabled={disabled}>
      <S.RadioInput
        ref={ref}
        disabled={disabled}
        name={name}
        value={value}
        {...props}
      />
      {label}
    </S.Label>
  )
);

RadioInput.displayName = "RadioInput";

RadioInput.propTypes = {
  disabled: bool,
  label: string.isRequired,
  name: string.isRequired,
  value: string.isRequired
};

RadioInput.defaultProps = {
  disabled: false
};

export default RadioInput;
